import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = (payload) => axios.post(`${API}/leads`, payload).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);
export const joinWaitlist = (email, product_id) =>
  axios.post(`${API}/waitlist`, { email, product_id }).then((r) => r.data);
export const getSchedule = () => axios.get(`${API}/schedule`).then((r) => r.data);
